import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const UPDATE_DETAILS_SUBMITTED = 'UPDATE_DETAILS_SUBMITTED';

export const useOnUpdateDetailsSubmitted = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: {
        formName: string;
    }) => {
        const event = new CustomEvent(UPDATE_DETAILS_SUBMITTED, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('update_details:submitted', handleEvent);

        return () => publicEventsAPIService.off('update_details:submitted', handleEvent);
    }, [handleEvent]);
};
